import React from 'react';
import { GiftIcon, LayersIcon, LibraryIcon, RulerIcon } from 'lucide-react';
import { SNAPSHOT, type SnapshotIcon } from '../../data/welding';
const ICONS: Record<SnapshotIcon, React.ComponentType<{
  className?: string;
}>> = {
  projects: LayersIcon,
  volumes: LibraryIcon,
  dimensions: RulerIcon,
  bonus: GiftIcon
};

/** Compact value snapshot directly under the hero. */
export function ValueStrip() {
  return <section aria-label="What's included" className="border-y border-arc/20 bg-surface" data-id="element-286" data-mp="38ajs97vlxurw">
      <ul className="mx-auto grid w-full max-w-6xl grid-cols-2 px-5 sm:px-8 lg:grid-cols-4" data-id="element-287" data-mp="349rkyk6apzy9">
        {SNAPSHOT.map((item, index) => {
        const Icon = ICONS[item.icon];
        return <li key={item.label} className={`flex items-center gap-3 py-4 sm:py-5 lg:justify-center ${index % 2 === 1 ? 'pl-4 sm:pl-6' : 'pr-2'} ${index >= 2 ? 'border-t border-white/10 lg:border-t-0' : ''} ${index > 0 ? 'lg:border-l lg:border-white/10 lg:pl-6' : ''}`} data-id="element-288" data-mp="2ukztse927joe" data-mpi={index}>
              <Icon className="h-5 w-5 shrink-0 text-arc-light" aria-hidden data-id="element-289" data-mp="1f9xxiduf5czv" />
              <span className="font-heading text-[1.05rem] font-semibold uppercase leading-tight tracking-[0.03em] text-white sm:text-[1.15rem]" data-id="element-290" data-mp="1fc1yoo0xnxwg">
                {item.label}
              </span>
            </li>;
      })}
      </ul>
    </section>;
}